import React from 'react'

export const HTMLContent: React.FC<ContentType> = ({ content, className }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
)

const Content: React.FC<ContentType> = ({ content, className }) => <div className={className}>{content}</div>

type ContentType = {
  content: any
  className: string
}

export default Content
